import { ModalHeader, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../Translations';

function LCModalHeader() {
  return (
    <ModalHeader className="px-10 py-6 w-full">
      <Typography variant="h5" fontWeight="semibold">
        <T kind="Choose How to Build Your Learning Collection" />
      </Typography>
    </ModalHeader>
  );
}

export default observer(LCModalHeader);
